import { useState, useEffect } from "react";
import { selectUsers } from "src/modules/users/selector";
import { useAppDispatch, useAppSelector } from "src/hooks/redux";
import {
  selectItems
} from "src/modules/spItems/selectors";
import { TooltipItem } from "src/utils/Tooltip";
import _ from "lodash";
import { Watch } from "src/components/ui-icons/card";
import Loading from "src/components/Loading";
import { UserAvatar } from "src/components/ui/avatar/Avatar";
import {
  historyByDocumentListName,
  historyChangeFieldsDocumentListName,
  myDocumentsListName,
  statusesListName,
  versionsByDocumentListName,
} from "src/api/config";
import moment from "moment";
import { getItemsRequest } from "src/modules/spItems/api";
import { docApprovers, docStatuses } from "src/api/config/systemSwitch";
import { containsAllIds } from "src/constants";
import { addUsers } from "src/modules/users/actions";

type Props = {
  versionView: any;
  documentCardID: any;
};

const VersionsCard = (props: Props) => {
  const { versionView, documentCardID } = props;
  const statuses = useAppSelector((state) => selectItems(state, statusesListName));
  const [approversObj, setApproversObj] = useState<any>({});
  const [dataVersions, setDataVersions] = useState<any>([]);
  const users: any = useAppSelector(selectUsers);
  const [historyCard, setHistoryCard] = useState<any>([]);
  const [historyFieldsCard, setHistoryFieldsCard] = useState<any>([]);
  const [customLoading, setCustomLoading] = useState(true);
  const [card, setCard] = useState<any>(null);
  const [versionsDocument, setVersionsDocument] = useState<any>([]);
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (!card?.ID) {
      return;
    }
    const versionsIds = versionsDocument
      .map((version: any) => version?.ID)
      .filter(Boolean);

    getItemsRequest({
      listName: historyByDocumentListName,
      filters: {
        DocumentID: card.ID,
        VersionDocument: false,
      },
    }).then((results) => {
      const historyCard = [...(results?.items || [])];

      getItemsRequest({
        listName: historyChangeFieldsDocumentListName,
        filters: {
          DocumentID: card.ID,
          Statuses: [docStatuses.edited, docStatuses.sendApproval],
          VersionDocument: false,
        },
      }).then((results) => {
        const historyFieldChange = [...(results?.items || [])];

        // Не отправляем запрос с пустым массивом ID
        if (versionsIds.length === 0) {
          setHistoryCard(historyCard);
          setHistoryFieldsCard(
            Array.from(
              new Map(
                historyFieldChange
                  .filter((history) =>
                    containsAllIds(history.Statuses, [
                      docStatuses.edited,
                      docStatuses.sendApproval,
                    ])
                  )
                  .map((item) => [item.DocumentID, item])
              ).values()
            )
          );
          setCustomLoading(false);
          return;
        }

        getItemsRequest({
          listName: historyByDocumentListName,
          filters: {
            DocumentID: versionsIds,
            VersionDocument: true,
          },
        }).then((results) => {
          const versionHistory = [...(results?.items || [])];
          const allHistory = [...versionHistory, ...historyCard];

          if (allHistory.length > 0) {
            let usersEmail: string[] = [];

            allHistory.forEach((item: any) => {
              Object.keys(item).forEach((key) => {
                const field = item[key];

                if (
                  field &&
                  !Array.isArray(field) &&
                  field.get_email
                ) {
                  const email = field.get_email();

                  if (email) {
                    usersEmail.push(email.toLowerCase());
                  }
                }

                if (
                  field &&
                  Array.isArray(field) &&
                  field.length > 0 &&
                  field[0]?.get_email
                ) {
                  field.forEach((user) => {
                    const email = user?.get_email?.();

                    if (email) {
                      usersEmail.push(email.toLowerCase());
                    }
                  });
                }
              });
            });

            usersEmail = _.uniq(usersEmail);

            if (usersEmail.length > 0) {
              const actualEmails = usersEmail.filter(
                (email) => !Object.prototype.hasOwnProperty.call(users, email)
              );

              if (actualEmails.length > 0) {
                dispatch(addUsers(actualEmails));
              }
            }
          }

          setHistoryCard(allHistory);

          // Тоже не делаем запрос с пустыми versionsIds
          getItemsRequest({
            listName: historyChangeFieldsDocumentListName,
            filters: {
              DocumentID: versionsIds,
              Statuses: [docStatuses.edited, docStatuses.sendApproval],
              VersionDocument: true,
            },
          }).then((results) => {
            setHistoryFieldsCard(
              Array.from(
                new Map(
                  [
                    ...(results?.items || []),
                    ...historyFieldChange,
                  ]
                    .filter((history) =>
                      containsAllIds(history.Statuses, [
                        docStatuses.edited,
                        docStatuses.sendApproval,
                      ])
                    )
                    .map((item) => [item.DocumentID, item])
                ).values()
              )
            );

            setCustomLoading(false);
          });
        });
      });
    });
  }, [card]);

  // Определяем согласующих для документа
  useEffect(() => {
    if (historyCard.length > 0) {
      let tempGroupsObj: any = {},
        tempApproversObj: any = {};
      // Получаем группы согласующих
      historyCard.forEach((history: any) => {
        let documentID = history.DocumentID;
        if (!history.VersionDocument) {
          if (!tempGroupsObj.hasOwnProperty(documentID)) {
            tempGroupsObj[documentID] = {};
          }
          if (history.ApprovalGroup) {
            if (history.Approved) {
              history.Approved.borderClassName = "ring-[#22AD5C] ring-2";
              history.Approved.Email =
                (history.Approved.get_email() &&
                  history.Approved.get_email().toLowerCase()) ||
                history.Approved.get_lookupValue().toLowerCase();
              tempGroupsObj[documentID][history.ApprovalGroup.get_lookupId()] =
                [history.Approved];
            } else if (history.Denied) {
              history.Denied.borderClassName = "ring-[#BA0C2F] ring-2";
              history.Denied.Email =
                (history.Denied.get_email() &&
                  history.Denied.get_email().toLowerCase()) ||
                history.Denied.get_lookupValue().toLowerCase();
              tempGroupsObj[documentID][history.ApprovalGroup.get_lookupId()] =
                [history.Denied];
            } else {
              tempGroupsObj[documentID][history.ApprovalGroup.get_lookupId()] =
                history.Approvers.map((approver: any) => {
                  return {
                    Email:
                      (approver.get_email() &&
                        approver.get_email().toLowerCase()) ||
                      approver.get_lookupValue().toLowerCase(),
                  };
                });
            }
          }

          delete tempGroupsObj[documentID][docApprovers.Creater]; // Удаляем создателя
          delete tempGroupsObj[documentID][12]; // Удаляем системные
        } else {
          if (!tempGroupsObj.hasOwnProperty(`${documentID}_version`)) {
            tempGroupsObj[`${documentID}_version`] = {};
          }
          if (history.ApprovalGroup) {
            if (history.Approved) {
              history.Approved.borderClassName = "ring-[#22AD5C] ring-2";
              history.Approved.Email =
                (history.Approved.get_email() &&
                  history.Approved.get_email().toLowerCase()) ||
                history.Approved.get_lookupValue().toLowerCase();
              tempGroupsObj[`${documentID}_version`][
                history.ApprovalGroup.get_lookupId()
              ] = [history.Approved];
            } else if (history.Denied) {
              history.Denied.borderClassName = "ring-[#BA0C2F] ring-2";
              history.Denied.Email =
                (history.Denied.get_email() &&
                  history.Denied.get_email().toLowerCase()) ||
                history.Denied.get_lookupValue().toLowerCase();
              tempGroupsObj[`${documentID}_version`][
                history.ApprovalGroup.get_lookupId()
              ] = [history.Denied];
            } else {
              tempGroupsObj[`${documentID}_version`][
                history.ApprovalGroup.get_lookupId()
              ] = history.Approvers.map((approver: any) => {
                return {
                  Email:
                    (approver.get_email() &&
                      approver.get_email().toLowerCase()) ||
                    approver.get_lookupValue().toLowerCase(),
                };
              });
            }
          }

          delete tempGroupsObj[`${documentID}_version`][docApprovers.Creater]; // Удаляем создателя
          delete tempGroupsObj[`${documentID}_version`][12]; // Удаляем системные
        }
        if (!history.VersionDocument) {
          tempApproversObj[documentID] = [];
        } else {
          tempApproversObj[`${documentID}_version`] = [];
        }
      });
      Object.keys(tempGroupsObj).forEach((keyDocument: string) => {
        Object.keys(tempGroupsObj[keyDocument]).forEach((keyGroup: any) => {
          if (tempApproversObj[keyDocument]) {
            tempApproversObj[keyDocument] = [
              ...tempApproversObj[keyDocument],
              tempGroupsObj[keyDocument][keyGroup][0],
            ];
          }
        });
      });
      setApproversObj((prevState: any) => {
        return { ...prevState, ...tempApproversObj };
      });
    }
  }, [historyCard]);

  useEffect(() => {
    getItemsRequest({
      listName: myDocumentsListName,
      filters: { ID: documentCardID },
    }).then((resultsCard) => {
      getItemsRequest({
        listName: versionsByDocumentListName,
        filters: { MainDocument: documentCardID },
      }).then((resultsVersions) => {
        setVersionsDocument([...resultsVersions.items]);
        setCard(resultsCard.items.length > 0 && resultsCard.items[0]);
      });
    });
  }, []);

  useEffect(() => {
    if (
      !customLoading &&
      "SUCCESS" &&
      card &&
      Object.keys(approversObj).length > 0
    ) {
      console.log("historyFieldsCard: ", historyFieldsCard);
      let tempVersionsTable: any = [];
      tempVersionsTable = [
        ...tempVersionsTable,
        {
          datePublication:
            card.PublicationDate &&
            moment(card.PublicationDate).format("DD.MM.YYYY"),
          approvers: approversObj[card.ID],
          status:
            ((card.Status.get_lookupId() === docStatuses.public ||
              card.Status.get_lookupId() === docStatuses.review) &&
              statuses.find((status: any) => status.ID === docStatuses.actual)[
              "Title"
              ]) ||
            (card.Status.get_lookupId() === docStatuses.archive &&
              statuses.find((status: any) => status.ID === docStatuses.archive)[
              "Title"
              ]) ||
            statuses.find((status: any) => status.ID === docStatuses.draft)[
            "Title"
            ],
          statusId:
            ((card.Status.get_lookupId() === docStatuses.public ||
              card.Status.get_lookupId() === docStatuses.review) &&
              statuses.find((status: any) => status.ID === docStatuses.actual)[
              "ID"
              ]) ||
            (card.Status.get_lookupId() === docStatuses.archive &&
              statuses.find((status: any) => status.ID === docStatuses.archive)[
              "ID"
              ]) ||
            statuses.find((status: any) => status.ID === docStatuses.draft)[
            "ID"
            ],
          active: !versionView,
          ID_HISTORY:
            historyFieldsCard.filter(
              (history: any) => history.DocumentID === Number(documentCardID)
            ).length > 0 &&
            historyFieldsCard.filter(
              (history: any) => history.DocumentID === Number(documentCardID)
            )[
            historyFieldsCard.filter(
              (history: any) => history.DocumentID === Number(documentCardID)
            ).length - 1
            ]["ID"],
          id: card.ID,
        },
      ];
      versionsDocument.forEach((item: any) => {
        let id_history =
          historyFieldsCard.filter(
            (history: any) => history.DocumentID === item.ID
          ).length > 0 &&
          historyFieldsCard.filter(
            (history: any) => history.DocumentID === item.ID
          )[
          historyFieldsCard.filter(
            (history: any) => history.DocumentID === item.ID
          ).length - 1
          ]["ID"];
        tempVersionsTable = [
          ...tempVersionsTable,
          {
            datePublication:
              ((item.Status.get_lookupId() === docStatuses.public ||
                item.Status.get_lookupId() === docStatuses.review ||
                item.Status.get_lookupId() === docStatuses.archive) &&
                item.PublicationDate &&
                moment(item.PublicationDate).format("DD.MM.YYYY")) ||
              statuses.find(
                (status: any) => status.ID === docStatuses.notPublic
              )["Title"],
            approvers: approversObj[`${item.ID}_version`],
            status:
              ((item.Status.get_lookupId() === docStatuses.public ||
                item.Status.get_lookupId() === docStatuses.review) &&
                statuses.find(
                  (status: any) => status.ID === docStatuses.notActual
                )["Title"]) ||
              (item.Status.get_lookupId() === docStatuses.archive &&
                statuses.find(
                  (status: any) => status.ID === docStatuses.archive
                )["Title"]) ||
              statuses.find((status: any) => status.ID === docStatuses.draft)[
              "Title"
              ], // Черновик, Архив, Не актуальная
            statusId:
              ((item.Status.get_lookupId() === docStatuses.public ||
                item.Status.get_lookupId() === docStatuses.review) &&
                statuses.find(
                  (status: any) => status.ID === docStatuses.notActual
                )["ID"]) ||
              (item.Status.get_lookupId() === docStatuses.archive &&
                statuses.find(
                  (status: any) => status.ID === docStatuses.archive
                )["ID"]) ||
              statuses.find((status: any) => status.ID === docStatuses.draft)[
              "ID"
              ],
            active: versionView && Number(versionView) === item.ID,
            ID_HISTORY: id_history,
            version: item.ID,
            id: item.MainDocument.get_lookupId(),
          },
        ];
      });
      const orderedTempVersionsTable = _.orderBy(
        tempVersionsTable,
        "ID_HISTORY",
        "asc"
      );
      setDataVersions(orderedTempVersionsTable);
    }
  }, [card, approversObj, customLoading, versionView]);

  return (
    <>
      {(customLoading && <Loading />) || (
        <div className="relative overflow-x-auto shadow-md sm:rounded-lg">
          <table className="w-full text-sm text-left rtl:text-right text-gray-500">
            <thead className="text-xs uppercase bg-gray-50">
              <tr>
                <th scope="col" className="px-6 py-3">
                  № версии
                </th>
                <th scope="col" className="px-6 py-3">
                  Дата публикации
                </th>
                <th scope="col" className="px-6 py-3">
                  Согласующие
                </th>
                <th scope="col" className="px-6 py-3">
                  Статус
                </th>
                <th scope="col" className="px-6 py-3">
                  Действия
                </th>
              </tr>
            </thead>
            <tbody>
              {dataVersions.length > 0 &&
                dataVersions.map((item: any, idx: number) => (
                  <tr className="bg-white border-b hover:bg-gray-50">
                    <th
                      scope="row"
                      className="px-6 py-4 font-medium whitespace-nowrap"
                    >
                      {(item.statusId === docStatuses.actual && (
                        <div className="flex items-center">
                          <div className="w-2 h-2 rounded-lg bg-[#22AD5C] mr-1.5"></div>
                          <span>{idx + 1}</span>
                        </div>
                      )) ||
                        (item.statusId === docStatuses.draft && (
                          <div className="flex items-center">
                            <div className="w-2 h-2 rounded-lg bg-[#00629B] mr-1.5"></div>
                            <span>{idx + 1}</span>
                          </div>
                        )) ||
                        ((item.statusId === docStatuses.notActual ||
                          item.statusId === docStatuses.archive) && (
                            <div className="flex items-center">
                              <div className="w-2 h-2 rounded-lg bg-[#D1D5DB] mr-1.5"></div>
                              <span>{idx + 1}</span>
                            </div>
                          ))}
                    </th>
                    <td className="px-6 py-4">
                      {(item.statusId === docStatuses.draft && (
                        <span>
                          {
                            statuses.find(
                              (status: any) =>
                                status.ID === docStatuses.notPublic
                            )["Title"]
                          }
                        </span>
                      )) || (
                          <span className="text-[#D1D5DB]">
                            {item.datePublication}
                          </span>
                        )}
                    </td>
                    <td className="px-6 py-4">
                      <div className="flex -space-x-1">
                        {item.approvers &&
                          item.approvers.length > 0 &&
                          item.approvers.map((item: any, i: number) => (
                            <TooltipItem
                              className="-translate-x-1"
                              position="top-left"
                              tooltipsText={
                                users[item["Email"]] &&
                                users[item["Email"]].displayName
                              }
                              key={i}
                            >
                              <UserAvatar
                                avatar={
                                  users[item["Email"]] &&
                                  users[item["Email"]].avatar
                                }
                                shortName={
                                  users[item["Email"]] &&
                                  users[item["Email"]].shortName
                                }
                                displayName={
                                  users[item["Email"]] &&
                                  users[item["Email"]].displayName
                                }
                                email={item["Email"]}
                                className={item.borderClassName || ""}
                              />
                            </TooltipItem>
                          ))}
                      </div>
                    </td>
                    <td className="px-6 py-4">
                      {(item.statusId === docStatuses.draft && (
                        <span>
                          {
                            statuses.find(
                              (status: any) => status.ID === item.statusId
                            )["Title"]
                          }
                        </span>
                      )) || (
                          <span className="text-[#D1D5DB]">{item.status}</span>
                        )}
                    </td>
                    <td className="px-6 py-4">
                      {(item.active && <span>Открыта</span>) || (
                        <a
                          href={`/dashboard/1/documents?documentCard=${item.id}${(item.version && "&version=" + item.version) || ""
                            }`}
                          target="_blank"
                          className="flex items-center py-3 px-6 rounded-md leading-[22px] shadow-custom text-[#00629B]"
                        >
                          <div className="mr-1.5">
                            <Watch />
                          </div>
                          <span>Посмотреть</span>
                        </a>
                      )}
                    </td>
                  </tr>
                ))}
            </tbody>
          </table>
        </div>
      )}
    </>
  );
};

export default VersionsCard;
